/**
 * Rhenus RVK API
 * \"Rhenus RVK user and admin API Definitions\"
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Observable } from "rxjs";
import { Headers } from "../Headers";
import { HttpResponse } from "../HttpResponse";

import { JSONClosedOrders } from "../model/jSONClosedOrders";
import { JSONfileDownload } from "../model/jSONfileDownload";
import { JSONOrderId } from "../model/jSONOrderId";
import { JSONresponseOpenFiles } from "../model/jSONresponseOpenFiles";
import { JSONresponseOpenUserOrders } from "../model/jSONresponseOpenUserOrders";
import { Response } from "../model/response";

export abstract class RvkWorkServiceInterface {
  /**
   * Rhenus intern Employee abort an order
   *
   * @param orderID Order number of the file
   */

  public abstract abortOrderUsingDELETE(
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract abortOrderUsingDELETE(
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * Customer wants to cancel his upload
   *
   * @param orderID Order number of the file
   */

  public abstract abortUploadUsingDELETE(
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract abortUploadUsingDELETE(
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * Admin has approved and now we send the order to the customer
   *
   * @param orderID Order number of the files to send to customer
   */

  public abstract approvedAdminFilesUsingPOST(
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract approvedAdminFilesUsingPOST(
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * User/Customer has approved and now we send the order to the Rhenus User
   *
   * @param orderID Order number of the files to send to Rhenus
   */

  public abstract approvedUserFilesUsingPOST(
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract approvedUserFilesUsingPOST(
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * Get all my closed orders as customer
   *
   * @param customername GetCustomer Closed Order by given customername
   */

  public abstract closedOrdersByGivenCustomerNameUsingGET(
    customername: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONClosedOrders[]>;
  public abstract closedOrdersByGivenCustomerNameUsingGET(
    customername: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONClosedOrders[]>>;
  /**
   * Give a file based on the orderID and fileName
   *
   * @param fileDownload fileDownload
   */

  public abstract downloadUserFileBodyUsingPOST(
    fileDownload: JSONfileDownload,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract downloadUserFileBodyUsingPOST(
    fileDownload: JSONfileDownload,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * Give a file based on the orderID and fileName
   *
   * @param fileName Name of the file
   * @param orderID Order number of the file
   */

  public abstract downloadUserFileUsingGET(
    fileName: string,
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract downloadUserFileUsingGET(
    fileName: string,
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * Save the vorschlag and auftrags file from the Rhenus intern employee.
   *
   * @param agreementfile Stream of the agreement file
   * @param auftragsfile Stream of the auftrags file
   * @param customername For this customers are the files
   * @param daystodeleteorder Days until delete the files and the order
   * @param vorschlagliste Stream of the vorschlag file
   */

  public abstract filesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    customername?: string,
    daystodeleteorder?: number,
    vorschlagliste?: Blob,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONOrderId>;
  public abstract filesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    customername?: string,
    daystodeleteorder?: number,
    vorschlagliste?: Blob,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONOrderId>>;
  /**
   * Get all my closed orders as customer
   *
   */

  public abstract getClosedOrdersCustomerUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONClosedOrders[]>;
  public abstract getClosedOrdersCustomerUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONClosedOrders[]>>;
  /**
   * Get all open orders for the customer (first step after upload from the Rhenus)
   *
   */

  public abstract getOpenFilesForUserUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONresponseOpenFiles[]>;
  public abstract getOpenFilesForUserUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONresponseOpenFiles[]>>;
  /**
   * Get all open orders for the customer (second step after edit the given files)
   *
   */

  public abstract openOrdersForUserUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONresponseOpenFiles[]>;
  public abstract openOrdersForUserUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONresponseOpenFiles[]>>;
  /**
   * Get all open orders for the Rhenus employee for the overview
   *
   */

  public abstract openRhenusOrdersUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONresponseOpenUserOrders[]>;
  public abstract openRhenusOrdersUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONresponseOpenUserOrders[]>>;
  /**
   * Get all open orders for the Customer for the overview
   *
   */

  public abstract openUserOrdersUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONresponseOpenUserOrders[]>;
  public abstract openUserOrdersUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONresponseOpenUserOrders[]>>;
  /**
   * Save the vorschlag and auftrags file from the external user
   *
   * @param agreementfile Stream of the agreement file
   * @param auftragsfile Stream of the auftrags file
   * @param orderid This is the orderId to find the order
   * @param vorschlagliste Stream of the vorschlag file
   */

  public abstract userFilesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    orderid?: number,
    vorschlagliste?: Blob,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONOrderId>;
  public abstract userFilesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    orderid?: number,
    vorschlagliste?: Blob,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONOrderId>>;
}
